<template lang="pug">
  .logo-bar
    a(href="/")
      Logo(variant="box")
      .logo-text {{ text }}
</template>

<script>
import Logo from "@/components/navigation/Logo.vue";

export default {
  components: { Logo },
  props: {
    text: String
  }
}
</script> 

<style lang="scss" scoped>
  .logo-bar {
    width:100%;
    min-width:250px;
    height: $logo-height;
    background: $primary;
    .logo-text {
      line-height:$logo-height;
      padding-left:10px;
      font-size:13px;

      @media all and (max-width:1180px) {
        font-size:11px;
      }

      color: $gradient-2;
      float:left;
    }
  }
</style>